module.exports = __webpack_public_path__ + "bc7e2f3d939135ebaf7494a1d01c4810.png";